import React, { useState, useEffect } from 'react'
import { useTranslation } from "react-i18next";
import {
    MDBBtn,
    MDBModalFooter,
} from "mdb-react-ui-kit";

function PhoneErrorAlertpop(props) {
    console.log("PhoneErrorAlertpop : props:" + JSON.stringify(props));
    const { t, i18n } = useTranslation();


    return (
        <>
            <div className='pb-3 text-justify'>
                {props.devices.length === 1 ? t("One_device") : t("multi_device")}
                <span className='red-dot mt-2 mx-2 d-inline-block'></span>
                {t("Blf_Error")}
            </div>

            <MDBModalFooter>
                <MDBBtn onClick={(e) => props.onClose(e)}>
                    {t("okay")}
                </MDBBtn>
            </MDBModalFooter>

        </>
    )
}
export default PhoneErrorAlertpop;